export default {
  web: {
    status: {
      notFoundTitle: "Página não encontrada",
      notFoundDescription: "A página que você está procurando não existe ou pode ter sido movida.",
      supportTitle: "Suporte",
      supportDescription: "Para obter ajuda com sua conta ou tirar dúvidas sobre nossos serviços, entre em contato por e-mail em support@linemate.io",
      goHome: "Ir para início",
      exploreTrends: "Explorar tendências",
      openTrends: "Abrir tendências",
      contactSupport: "Contatar suporte",
    },
    download: {
      title: "Baixar Linemate",
      subtitle: "Disponível para iOS, Android e web.",
      ios: "Baixar para iOS",
      android: "Baixar para Android",
    },
    manageSubscription: {
      title: "Gerenciar sua assinatura",
      web: "Gerenciar na web",
      ios: "Gerenciar no iOS",
      android: "Gerenciar no Android",
    },
    auth: {
      loginTitle: "Entrar no Linemate",
      signupTitle: "Criar conta no Linemate",
      noAccount: "Não tem uma conta?",
      alreadyHaveAccount: "Já tem uma conta?",
      signUp: "Criar conta",
      setupError: "Algo deu errado ao configurar sua conta. Talvez você consiga concluir o processo pela página de perfil.",
      usernameTooShort: "Nome de usuário muito curto (mín. 6 caracteres).",
      usernameAlphaNumeric: "O nome de usuário pode conter apenas letras e números.",
      termsPrefix: "Ao continuar, você concorda com os",
      termsOfService: "Termos de Serviço",
      privacyPolicy: "Política de Privacidade da Linemate.",
      oddsFormatTitle: "Preferências de formato de odds",
      oddsFormatDescription: "Antes de continuarmos para o Linemate, defina sua preferência para exibir odds no formato americano ou decimal.",
      oddsFormat: "Formato de odds",
      passwordReset: {
        forgotTitle: "Esqueci minha senha",
        resetTitle: "Redefinir senha",
        instructions: "Insira o email associado à sua conta e enviaremos um link para redefinir sua senha.",
        sentInstructions: "Você receberá um email de redefinição de senha em breve. Siga o link no email para redefinir sua senha.",
        sendInstructions: "Enviar instruções",
        resendInstructions: "Reenviar instruções",
        returnToLogin: "Voltar para login",
        signupPrompt: "Não tem uma conta? Criar conta",
        sendError: "Algo deu errado ao enviar as instruções de redefinição de senha. Tente novamente mais tarde.",
      },
      changePassword: {
        title: "Alterar sua senha",
        subtitle: "Insira sua nova senha.",
        newPassword: "Nova senha",
        confirmNewPassword: "Confirmar nova senha",
        passwordChanged: "Senha alterada",
        invalidLink: "Não foi possível redefinir sua senha. O link que você está usando é inválido ou expirou.",
        genericError: "Não foi possível concluir sua solicitação. Tente novamente mais tarde ou envie o seguinte código para nossa equipe analisar: {{code}}",
      },
    },
    inputSelection: {
      clear: "Limpar",
    },
  },
};
